import { useEffect } from 'react';

import AppRoutes from './routes/appRoutes';
import { connectWebSocket, disconnectWebSocket } from './service/webSocket';
import useUser from './store/useUser';

const App = () => {
  const token = useUser((state) => state.user.token);

  useEffect(() => {
    if (token) {
      connectWebSocket();
    } else {
      disconnectWebSocket();
    }

    return () => {
      disconnectWebSocket();
    };
  }, [token]);

  return <AppRoutes />;
};

export default App;
